import { faCircleDollar, faUsers } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "styled-components";

interface StatisticProps {
  count?: number | string;
  type: "earnings" | "members" | "patients";
}

export const Statistic: React.FC<StatisticProps> = ({ count, type }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const getIcon = () => {
    switch (type) {
      case "earnings":
        return <FontAwesomeIcon icon={faCircleDollar} />;
      case "members":
        return <FontAwesomeIcon icon={faUsers} />;
      case "patients":
        return <FontAwesomeIcon icon={faUsers} />;
      default:
        return "";
    }
  };

  const getLabel = () => {
    switch (type) {
      case "earnings":
        return t("admin.overview.monthly_earnings", { month: format(new Date(), "MMMM") });
      case "members":
        return t("admin.overview.team_members");
      case "patients":
        return t("admin.overview.active_patients");
      default:
        return "";
    }
  };

  return (
    <Container className={type}>
      <IconContainer className={type}>{getIcon()}</IconContainer>
      <Stack spacing={0.5}>
        <Typography variant="h3" color={theme.colors.redesign.db100}>
          {count !== undefined ? count : "-"}
        </Typography>
        <Typography variant="subtitle1" color={theme.colors.redesign.db60}>
          {getLabel()}
        </Typography>
      </Stack>
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 12px;

  &.earnings {
    background-color: ${({ theme }) => theme.colors.redesign.p10};
  }

  &.members {
    background-color: ${({ theme }) => theme.colors.redesign.t10};
  }

  &.patients {
    background-color: ${({ theme }) => theme.colors.redesign.b10};
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 48px;
  border-radius: 8px;

  & > svg {
    font-size: 20px;
  }

  &.earnings {
    background-color: ${({ theme }) => theme.colors.redesign.p20};
    color: ${({ theme }) => theme.colors.redesign.p100};
  }

  &.members {
    background-color: ${({ theme }) => theme.colors.redesign.t20};
    color: ${({ theme }) => theme.colors.redesign.t100};
  }

  &.patients {
    background-color: ${({ theme }) => theme.colors.redesign.b20};
    color: ${({ theme }) => theme.colors.redesign.b100};
  }
`;
